import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";

export default (generalLedgerAccountState: GeneralLedgerAccountState) => {
    let returnVal = "Undefined";
    switch (generalLedgerAccountState) {
        case GeneralLedgerAccountState.Active:
            returnVal = "Active";
            break;
        case GeneralLedgerAccountState.Deleted:
            returnVal = "Deleted";
            break;
    }
    return returnVal;
}